import createRemoteSettingHook from '@/utils/user/createRemoteSettingHook';

interface HideFeedCreditsSetting {
  hidden: boolean;
}

const REMOTE_SETTING_NAME = 'genai_studio_hide_feed_credits';

const DEFAULT_SETTING: HideFeedCreditsSetting = {
  hidden: false,
};

const isHideFeedCreditsSetting = (
  settings: unknown
): settings is HideFeedCreditsSetting =>
  typeof settings === 'object' &&
  settings !== null &&
  typeof (settings as HideFeedCreditsSetting).hidden === 'boolean';

const { useSetting } = createRemoteSettingHook({
  name: REMOTE_SETTING_NAME,
  defaultValue: DEFAULT_SETTING,
  validate: isHideFeedCreditsSetting,
  select: (settings) => settings.hidden,
});

/**
 * Remote-setting gate for the preset feed's credit cost chip. When
 * `genai_studio_hide_feed_credits.hidden` is `true`, the chip is hidden and
 * the feed's quote requests (action bar and inputs sheet) are skipped once
 * the setting resolves. Deliberately feed-scoped: the Create screen's cost
 * display (`CreateFooter`) is not covered. Defaults to shown; fetched once
 * per session.
 */
const useHideFeedCredits = useSetting;

export default useHideFeedCredits;
